import { useState, useEffect } from "react";
import { CATALOG_MANAGEMENT_SERVICE } from "src/utils/Api";
import __ from "src/utils/Translations";
import sendBatchRequests from "src/utils/Api/sendBatchRequests";

export default function useBusinessCategories(
  asOption = false,
  filterField = null,
  filterValue = null,
  idAsIri = false
) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () =>
      sendBatchRequests({
        filterField,
        filterValue,
        idAsIri,
        asOption,
        IRI_PREFIX,
        requestParams: {
          service: CATALOG_MANAGEMENT_SERVICE,
          path: "/business-categories",
          method: "GET",
          mockData,
        },
        setData,
      });

    fetchData();
  }, [filterField, filterValue, idAsIri, asOption, setData]);

  return data;
}

const mockData = [
  {
    id: "7105a40b-a629-4035-a79e-f1b7c6c50ea8",
    name: "Edukacja",
    active: true,
    type: "product",
    activeFrom: "2020-02-12T00:00:00+00:00",
    activeTo: "2020-02-12T00:00:00+00:00",
    helpCenterUrl: "/test/example",
    breadcrumbs: [],
    position: 1,
  },
  {
    id: "7105a40b-a629-4035-a79e-f1b7c6c50ea2",
    name: "Sklepy",
    active: true,
    activeFrom: "2020-02-12T00:00:00+00:00",
    activeTo: "2020-02-12T00:00:00+00:00",
    helpCenterUrl: "/test/example",
    breadcrumbs: [
      { id: "7105a40b-a629-4035-a79e-f1b7c6c50ea8", name: "Edukacja" },
    ],
    position: 1,
  },
  {
    id: "7105a40b-a629-4035-a79e-f1b7c6c50ea3",
    name: "Książki",
    active: true,
    type: "product",
    activeFrom: "2020-02-12T00:00:00+00:00",
    activeTo: "2020-02-12T00:00:00+00:00",
    helpCenterUrl: "/test/example",
    breadcrumbs: [
      { id: "7105a40b-a629-4035-a79e-f1b7c6c50ea8", name: "Educkacja" },
      { id: "7105a40b-a629-4035-a79e-f1b7c6c50ea2", name: "Sklepy" },
    ],
    position: 1,
  },
  {
    id: "7105a40b-a629-4035-a79e-f1b7c6c50ea4",
    name: "Kultura",
    active: true,
    type: "product",
    activeFrom: "2020-02-12T00:00:00+00:00",
    activeTo: "2020-02-12T00:00:00+00:00",
    helpCenterUrl: "/test/example",
    breadcrumbs: [],
    position: 1,
  },
];

export const IRI_PREFIX = "/api/catalog-management/v1/rest/business-categories";
